import { render } from "./ethoca-decision.vue?vue&type=template&id=2ef73bc7&scoped=true"
import script from "./ethoca-decision.vue?vue&type=script&lang=js"
export * from "./ethoca-decision.vue?vue&type=script&lang=js"

import "./ethoca-decision.vue?vue&type=style&index=0&id=2ef73bc7&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef73bc7"]])

export default __exports__